import api from 'Common/Client/Interceptor';


const courseCategoryService = {
  // Fetch all course categories with details
getCourseCategories: async (onlyWithSubCategories = true, pageNumber = 1, pageSize = 10) => {
  try {
    const response = await api.get(`/indv/CourseCategory/list-with-details`, {
      params: {
        onlyWithSubCategories,
        pageNumber,
        pageSize
      }
    });
    console.log("******************************VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVin serivce categories",response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching course categories:", error);
    throw error;
  }
},



  createExpertSkills: async (subCategoryIds) => {
    try {
      const response = await api.post(
        `/indv/CourseCategory/expert/skill-sets`,
        {
          subCategoryIds: subCategoryIds
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error creating expert skills:', error);
      throw error;
    }
  }
};

export const fetchExpertSkills = async () => {
  try {
    const response = await api.get("/indv/CourseCategory/expert/skill-sets");

    console.log("................ expert skills  data:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Error fetching expert skills:", error);
    throw error;
  }
};


export default courseCategoryService;